import { createApp } from 'vue'
import App from './App.vue'
import TiersDisplay from './TiersDisplay.vue'

const mountTimer = document.querySelector('#timer')
const mountTiers = document.querySelector('#tiers-display')

if (mountTimer) {
    const props = {
        endpoint: mountTimer.dataset.endpoint,
        seconds: parseInt(mountTimer.dataset.seconds || 0, 10),
        totalPresses: parseInt(mountTimer.dataset.totalPresses || 0, 10),
        tiers: mountTimer.dataset.tiers
            ? JSON.parse(mountTimer.dataset.tiers)
            : [],
        isAuthenticated: mountTimer.dataset.isAuthenticated === 'true',
        hasPendingPress: mountTimer.dataset.hasPendingPress === 'true',
    }

    createApp(App, props).mount('#timer')
}

if (mountTiers) {
    const props = {
        seconds: parseInt(mountTiers.dataset.seconds || 0, 10),
        tiers: mountTiers.dataset.tiers
            ? JSON.parse(mountTiers.dataset.tiers)
            : [],
    }

    createApp(TiersDisplay, props).mount('#tiers-display')
}
